import ViewControlsOverlay from './ViewControlsOverlay';

export default ViewControlsOverlay;